import ChartFactory from "src/charts/ChartFactory";
import { getChartEntry } from "src/charts/registry";
import WidgetPlaceholder from "./WidgetPlaceholder";

type ChartWidgetProps = {
  isLoading: boolean;
  title: string;
  description?: string | null;
  data: unknown;
  spec?: Record<string, unknown>;
  chartType: string;
  widgetId?: string | number;
};

export default function ChartWidget({
  isLoading,
  title,
  description,
  data,
  spec,
  chartType,
  widgetId,
}: ChartWidgetProps) {
  if (isLoading || data === undefined || data === null) {
    return <WidgetPlaceholder height={320} />;
  }

  const entry = getChartEntry(chartType);
  const fillHeight = entry?.fillHeight ?? false;

  return (
    <ChartFactory
      chartType={chartType}
      chartId={`${widgetId ?? `${title?.replace(/\s+/g, "-") || "chart"}-${chartType}`}`}
      title={title}
      description={description}
      data={data}
      spec={spec}
      fillHeight={fillHeight}
    />
  );
}
